import axios, { AxiosResponse } from "axios"; // Assuming Axios is installed
import { store } from "../store/store";
import { defaultHeadersWithToken } from "../constants/constants";
import { ServerResponse_ } from "@/interfaces/Server";
import { Seller } from "@/interfaces/Seller";
import { liste_vendeurs_avec_demandes_url } from "@/constants/urls";

export const getVendeursWithRequests = async (
  sourceId: number
): Promise<AxiosResponse<ServerResponse_<Seller[]>>> => {
  const accessToken = store.getState().authentication.accessToken;

  try {
    const response: AxiosResponse<ServerResponse_<Seller[]>> = await axios.get(
      liste_vendeurs_avec_demandes_url + sourceId,
      {
        headers: defaultHeadersWithToken(accessToken),
      }
    );
    return response;
  } catch (error: any) {
    return error.response;
  }
};
